import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseDateYear extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateYear {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateYear;

  public mode() {
    return TEDParseDateTimeMode.pdmY;
  }
}
